import { createSelector } from '@reduxjs/toolkit';
import { getSearchResults } from './searchSelectors';
import reduce from 'lodash/reduce';

export const getSearchGa4Results = createSelector(getSearchResults, (results) => {
  const searchResults = reduce(
    results,
    (accum, item) => {
      const mappedItem = {
        property: {
          ...item?.property,
          hasOffer: item?.offer?.promotion?.name ? true : false,
          promotionName: item?.offer?.promotion?.name,
          hasDepositPayableOffer: item?.property?.hasDepositPayableOffer,
          recommend: false,
          rebook: false,
        },
        roomType: item.roomType,
        offer: {
          charges: {
            total: item?.offer?.charges?.total,
            totalCash: item?.offer?.charges?.totalCash,
            strikethrough: item?.offer?.charges?.strikethrough || null,
          },
          luxOffer: item.offer?.luxOffer,
          allocationsAvailable: item.offer?.allocationsAvailable,
        },
      };
      return [...accum, mappedItem];
    },
    [],
  );
  return searchResults;
});
